import { FieldType } from '@/components/Form';
import { DatabaseField } from '@/modules/corporate/modules/database/fields/types';

import CheckboxFieldEditorConfig from './Editor/config';
import Cell from './Cell';
import { CheckboxFieldStaticConfig } from './config';
import FilterInput from './FilterInput';
import CheckBoxOperators from './operators';
import { adaptFormData, parseFormData } from './utils';

const CheckBoxField: DatabaseField = {
  ...CheckboxFieldStaticConfig,
  Table: {
    Cell,
    EditableCell: () => null,
    FilterInput,
    operators: CheckBoxOperators,
  },
  Viewer: {
    adaptFormData,
    parseFormData,
    fieldType: FieldType.Checkbox,
  },
  Editor: CheckboxFieldEditorConfig,
};

export default CheckBoxField;
